import { Tag } from "antd"
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, DisconnectOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { CONNECTION_STATUS } from "constants/powertranz"

// Icon + text carry the status; colour only reinforces it.
const STATUS_APPEARANCE = {
  [CONNECTION_STATUS.ACTIVE]: { color: "success", icon: <CheckCircleOutlined /> },
  [CONNECTION_STATUS.PENDING_VERIFICATION]: { color: "processing", icon: <ClockCircleOutlined /> },
  [CONNECTION_STATUS.INVALID]: { color: "error", icon: <CloseCircleOutlined /> },
  [CONNECTION_STATUS.DISCONNECTED]: { color: "default", icon: <DisconnectOutlined /> }
}

const PowerTranzStatus = ({ connectionStatus }) => {
  const { t } = useTranslation()
  const status = connectionStatus || CONNECTION_STATUS.DISCONNECTED
  const { color, icon } = STATUS_APPEARANCE[status] || STATUS_APPEARANCE[CONNECTION_STATUS.DISCONNECTED]

  return (
    <Tag color={color} icon={icon}>
      {t(`powertranz.settings.status.${status}`)}
    </Tag>
  )
}

PowerTranzStatus.propTypes = {
  connectionStatus: PropTypes.oneOf(Object.values(CONNECTION_STATUS))
}

export default PowerTranzStatus
